import React from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';
import Button from '@wix/da-shared-react/pkg/Button';
import SortBy from '../../_partials/WidgetEditControls/SortBy';
import ConfigPopover from '../../_partials/ConfigPopover';

import s from './WatchedDeviantsConfigPopover.scss';

export interface Props {
  moduleId: number;
  withManageLink?: boolean;
  onClose(): void;
}

export const WatchedDeviantsConfigPopover: React.SFC<
  Props & WithTranslation
> = props => {
  return (
    <ConfigPopover withPaddings={false} onClose={props.onClose} width={230}>
      {props.withManageLink && (
        <Button
          target="_blank"
          href="/watching"
          className={s['manage-button']}
          view="b14"
          height="medium"
        >
          {props.t('widgets.watching.editWatchList')}
        </Button>
      )}
      <SortBy
        moduleId={props.moduleId}
        paramName="sortBy"
        labels={{
          newest: 'common.sortOrder.newest',
          oldest: 'common.sortOrder.oldest',
        }}
        close={props.onClose}
      />
    </ConfigPopover>
  );
};
WatchedDeviantsConfigPopover.displayName = 'WatchedDeviantsConfigPopover';

export default withTranslation()(WatchedDeviantsConfigPopover);
